<template>
	<v-tooltip top content-class="tooltip-content" :z-index="99999" :open-delay="OPEN_HOVER_DELAY_TIME" :close-delay="CLOSE_HOVER_DELAY_TIME">
		<template v-slot:activator="{ on, attrs }">
			<span v-bind="attrs" v-on="on">
				<div class="data-chip-missing">
					<IconWarning class="warning-icon-chip" />
					<span class="ml-1 missing-text"> {{ missingDataInputMessage }} </span>
				</div>
			</span>
		</template>
		<div class="">
			<div class="tooltip-text">{{ missingDataInputTooltip }}</div>
			<div>(source: {{ content }})</div>
		</div>
	</v-tooltip>
</template>

<script>
import IconWarning from '@/components/FlowTreeBlock/assets/icon-exclamation-unknown.svg';
import { MISSING_DATA_INPUT_MESSAGE } from './data-chip.const';
const OPEN_HOVER_DELAY_TIME = 300; // daley until open of tooltip on hover
const CLOSE_HOVER_DELAY_TIME = 0; // daley until close of tooltip on hover

export default {
	name: 'DataMissingChip',
	components: {
		IconWarning,
	},
	props: {
		contentObj: { type: Object },
	},
	computed: {
		missingDataInputMessage() {
			return MISSING_DATA_INPUT_MESSAGE;
		},
		missingDataInputTooltip() {
			return `We are missing some data in order to process this chip information, please see if the step it refers to still exists, and if the data expected here still exists.`;
		},
		content() {
			return this.contentObj.content;
		},
	},
	data() {
		return {
			OPEN_HOVER_DELAY_TIME,
			CLOSE_HOVER_DELAY_TIME,
		};
	},
};
</script>

<style scoped lang="scss">
.warning-icon-chip {
	position: relative;
	top: 2px;
}
.data-chip-missing {
	position: relative;
	display: inline;
	color: #f79836;
	background-color: #fef0e3;
	border: 1px solid #f79836;
	border-radius: 5px;
	padding: 2px 4px;
	.missing-text {
		top: 1px;
	}
}
</style>
